import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
    return (
        <div className="mx-auto flex min-h-[60vh] max-w-3xl flex-col items-center justify-center px-4 py-24 text-center" data-testid="not-found-page">
            <p className="font-display text-7xl font-extrabold cyan-gradient-text">404</p>
            <h1 className="mt-4 font-display text-2xl font-bold text-white">This page clocked out</h1>
            <p className="mt-2 text-slate-400">Our AI employees work 24/7, but this page doesn't exist.</p>
            <Link
                to="/"
                data-testid="not-found-home-link"
                className="mt-8 inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-blue-600 to-cyan-500 px-6 py-3 text-sm font-semibold text-white"
            >
                <ArrowLeft className="h-4 w-4" /> Back to Home
            </Link>
        </div>
    );
}
